import { withAuthenticationRequired } from "@auth0/auth0-react"
import React from "react"
import { LoaderPage } from "pages/LoaderPage"
import { AuthenticationGuardProps } from "types/auth"



export const Auth0AuthenticationGuard: React.FC<AuthenticationGuardProps> = ({
    component,
}) => {
    const Component = withAuthenticationRequired(component, {
        onRedirecting: LoaderPage,
    })

    return <Component />
}
